<template>
  <div class="project-team">
    <el-table :data="projectData" style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="number" label="采购申请编号" width="120">
      </el-table-column>
      <el-table-column prop="name" label="采购项目">
      </el-table-column>

      <!-- <el-table-column prop="department.name" label="申请部门">
      </el-table-column> -->

      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="150px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>
          <!-- <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button> -->
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  export default {
    props: ['contractId'],
    components: {
      UserInfo,
      ApprovalStatus,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
      })
    },
    data() {
      return {
        // 列表
        loading: true,
        projectData: [],
        // fatherData: [],
      }
    },
    mounted() {
      // 获取列表
      this.getLists()
    },
    methods: {
      // 显示审批详情
      projectDetail(row) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          tableType: row.flow.flowsource,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      // projectDetail(row) {
      //   console.log(row.id)
      //   this.$router.push("/Project/Detail/" + row.id)
      // },
      // 获取列表
      getLists() {
        ajax.get('/contract/relate/purchase/' + this.contractId, '', (res) => {
          this.loading = false
          this.projectData = res.vo.array
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/contract/purchaseList.vue